<!-- Content Header (Page header) -->
<section class="content-header p-1">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Catálogo de Magnitudes</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                    <li class="breadcrumb-item active">Lista de Magnitudes</li>
                </ol>
            </div>
        </div>
    </div>
</section>

<!-- Main content -->
<section class="content p-0">
    <div class="container-fluid">
        <div class="card">
            <div class="card-header">
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-widget="collapse" data-toggle="tooltip"
                        title="Collapse">
                        <i class="fa fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-widget="remove" data-toggle="tooltip"
                        title="Remove">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3 form-group form-group-sm">
                        <mat-form-field>
                            <mat-label>Buscar</mat-label>
                            <input matInput (keyup)="filterTable($event)" appearance="legacy" placeholder="Buscar">
                        </mat-form-field>
                    </div>
                    <div class="col-md-9">
                        <div class="form-group">
                            <div class="example-button float-right">
                                <button mat-raised-button color="primary" (click)="new()" class="m-1">
                                    <mat-icon>create</mat-icon> Nueva Magnitud
                                </button>
                                <button mat-raised-button class="btn-green m-1">
                                    <mat-icon>download</mat-icon> Exportar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="table-1" mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>

                        <ng-container matColumnDef="nombreMagnitud">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Magnitud</th>
                            <td mat-cell *matCellDef="let row">
                                {{ row?.nombreVariable }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="options">
                            <th mat-header-cell *matHeaderCellDef> Opciones </th>
                            <td mat-cell *matCellDef="let row" class="catalog-list-options">
                                <button color="primary" class="update-button" mat-icon-button aria-label="Modificar" title="Editar"
                                    (click)="update(row)">
                                    <mat-icon class="small-icon">border_color</mat-icon>
                                </button>
                                <button class="update-button" mat-icon-button aria-label="Consultar" title="Ver"
                                    (click)="view(row)">
                                    <mat-icon class="small-icon">remove_red_eye</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <br />
                <mat-paginator [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>
            <div class="card-footer">Lista de Magnitudes</div>
        </div>
    </div>
</section>